import { render, staticRenderFns } from "./TargetGoalForm.vue?vue&type=template&id=559355d3&scoped=true"
import script from "./TargetGoalForm.vue?vue&type=script&lang=js"
export * from "./TargetGoalForm.vue?vue&type=script&lang=js"
import style0 from "./TargetGoalForm.vue?vue&type=style&index=0&id=559355d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559355d3",
  null
  
)

export default component.exports